import type { SubCustomersTranslations } from './types'

export const arTranslations: SubCustomersTranslations = {
  title: 'العملاء',
  subtitle: 'إدارة عملائك',
  addCustomer: 'إضافة عميل',
  editCustomer: 'تعديل العميل',
  deleteCustomer: 'حذف العميل',
  customerCode: 'الرمز',
  customerName: 'الاسم',
  customerPhone: 'الهاتف',
  selectCustomer: 'اختر العميل',
  changeCustomer: 'تغيير العميل',
  noCustomer: 'لم يتم تعيين عميل',
  addNewCustomer: 'إضافة عميل جديد',
  createNewCustomer: 'إنشاء عميل جديد',
  hideCreate: 'إخفاء',
  namePlaceholder: 'أدخل اسم العميل',
  phonePlaceholder: 'أدخل رقم الهاتف (اختياري)',
  searchPlaceholder: 'البحث في العملاء...',
  noCustomersFound: 'لا يوجد عملاء',
  deleteConfirmTitle: 'حذف العميل',
  deleteConfirmDescription: 'هل أنت متأكد من حذف هذا العميل؟',
  saveSuccess: 'تم حفظ العميل بنجاح',
  saveError: 'فشل في حفظ العميل',
  deleteSuccess: 'تم حذف العميل بنجاح',
  deleteError: 'فشل في حذف العميل',
  customerType: 'النوع',
  typeRegular: 'عادي',
  typePlaceholder: 'عميل غير معروف',
  typePlaceholderHint: 'عميل مؤقت عندما لا يكون العميل الفعلي معروفاً بعد. استبدله في الطلب بعد التسليم.',
  placeholderOnOrderHint: 'عميل غير معروف — استبدله بالعميل الفعلي بعد التسليم',
  selectTenantToAdd: 'اختر عميلاً من الأعلى لإضافة عملاء فرعيين',
  typeAll: 'الكل',
  mainCustomer: 'العميل الرئيسي',
  total: 'الإجمالي',
  noCustomersFoundHint: 'جرّب بحثاً أو نوعاً آخر',
  loadError: 'تعذّر تحميل العملاء',
  searching: 'جاري البحث…',
  remove: 'إزالة',
}
